var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('v-dialog',{attrs:{"value":_vm.open,"max-width":"1120"},on:{"input":function($event){return _vm.$emit('update:dialog', false)}}},[_c('div',{staticClass:"codebox-dialog-content"},[_c('iframe',{attrs:{"src":"https://breakdance.com/codebox-iframe/"}})])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }